import React, { useEffect } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { TeamShipHealth } from './battleship-quiz';

import './styles/header.css';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import { TeamScoreboard } from './team-scoreboard';
import { useQuizFocus } from 'hooks';
import { NavUtils } from 'utils';
import { useEventContext } from 'contexts';
import { useNavigate } from 'react-router-dom';
import { CountdownClock } from 'components';

interface Props {
    title: string;
    eventLogo?: string | null;
    correctAnswers: number;
    incorrectAnswers: number;
    teamShipStatus: TeamShipHealth[];
    quizTimelimitSeconds?: number | null;
    onQuizExit?: () => void;
}

export const Headers = (props: Props) => {
    const [open, setOpen] = React.useState(false);
    const navigate = useNavigate();
    const event = useEventContext();
    useQuizFocus();

    useEffect(() => {
        const handleTabClosing = () => {
            onExitQuizClick();
        }
        
        const alertUser = (event: any) => {
            event.preventDefault()
            event.returnValue = 'Are you sure you want to end your quiz?'
        }

        window.addEventListener('beforeunload', alertUser)
        window.addEventListener('unload', handleTabClosing)
        return () => {
            window.removeEventListener('beforeunload', alertUser)
            window.removeEventListener('unload', handleTabClosing)
        }
    })

    const openTeamStatusDialog = () => {
        setOpen(true);
    };

    const handleCloseTeamStatusDialog = () => {
        setOpen(false);
    };

    const onExitQuizClick = () => {
        if(props.onQuizExit) {
            props.onQuizExit();
            return;
        }
        navigate(NavUtils.getQuizSelectorPath(event?.alias));
    };

    const renderDialog = () => (
        <Dialog open={open} onClose={handleCloseTeamStatusDialog} scroll="paper" maxWidth={false} aria-labelledby="scoreboard-dialog-title">
            <DialogTitle id="scoreboard-dialog-title">Team Statuses</DialogTitle>
            <DialogContent dividers={true}>
                <TeamScoreboard teamShipStatus={props.teamShipStatus} />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseTeamStatusDialog}>Close</Button>
            </DialogActions>
        </Dialog>
    );

    return (
        <div className="headers">
            {!!props.eventLogo && <img className="header-logo" src={props.eventLogo} alt="Event logo" />}
            <span className="title" style={{ fontFamily: 'cursive', fontWeight: 800, paddingLeft: 30 }}>
                {props.title}
            </span>

            <div className="scoreboard">
                {!!props.quizTimelimitSeconds && (
                    <CountdownClock countdownSeconds={props.quizTimelimitSeconds} onTimeout={onExitQuizClick} />
                )}
                <Tooltip title="View Team Statuses">
                    <IconButton className="team-scores-button" onClick={openTeamStatusDialog}>
                        <VisibilityIcon />
                    </IconButton>
                </Tooltip>

                <Tooltip title="Total correctly answered questions">
                    <span className="correct-answers-count">{props.correctAnswers}</span>
                </Tooltip>
                <span className="score-separator">:</span>
                <Tooltip title="Total incorrectly answered questions">
                    <span className="incorrect-answers-count">{props.incorrectAnswers}</span>
                </Tooltip>
                <Tooltip title="Exit Quiz">
                    <IconButton className="exit-button" onClick={onExitQuizClick}>
                        <CloseIcon />
                    </IconButton>
                </Tooltip>
            </div>
            {renderDialog()}
        </div>
    );
};
